import MODULE from "@/flit2go-web-core/interfaces/moduleConstants";
import store from "@/flit2go-web-core/store/index";

import {
  CUSTOMERS,
  CUSTOMERS_FORM,
  DEALER_BILLING,
  DEALER_LIST,
  DEALER_DETAIL,
  DEALER_HOME,
  DEVICES_LIST,
  MODELS,
  MODEL_FORM,
  SUBSCRIPTIONS,
  SUBSCRIPTION_FORM,
  VEHICLES,
  VEHICLE_FORM
} from "@/modules/Dealer/routesInterface";

const menu = {
  code: MODULE.DEALER.CODE,
  name: "dealer",
  label: "common.dealer",
  link: DEALER_HOME,
  children: [],
  createChildren: [],
};

const submenus = [
  { code: MODULE.DEALER.DASHBOARD,
    icon: "dashboard",
    label: "common.dashboard",
    link: DEALER_HOME,
    name: "home",
    tooltip: "common.dashboard"
  },
  { code: MODULE.DEALER.VEHICLES,
    icon: "vehicles",
    label: "common.vehicles",
    link: VEHICLES,
    name: "vehicles",
    tooltip: "common.vehicles"
  },
  { code: MODULE.DEALER.DEVICES,
    icon: "processor-1",
    label: "common.devices",
    link: DEVICES_LIST,
    name: "devices",
    tooltip: "common.devices"
  },
  { code: MODULE.DEALER.MODELS,
    label: "common.models",
    link: MODELS,
    icon: "models",
    name: "models",
    tooltip: "common.models"
  },
  { code: MODULE.DEALER.CUSTOMERS,
    icon: "user",
    label: "common.customers",
    link: CUSTOMERS,
    name: "customers",
    tooltip: "common.customers"
  },
  { code: MODULE.DEALER.SUBSCRIPTIONS,
    icon: "subscription",
    label: "common.subscriptions",
    link: SUBSCRIPTIONS,
    name: "subscriptions",
    tooltip: "common.subscriptions"
  },
  { code: MODULE.DEALER.BILLING,
    icon: "billing",
    label: "common.billing",
    link: DEALER_BILLING,
    name: "billing",
    tooltip: "common.billing"
  },
];

const submenusCreate = [
  {
    code: MODULE.DEALER.VEHICLES,
    label: "common.vehicle",
    link: VEHICLE_FORM,
    name: "vehicle",
  },
  {
    code: MODULE.DEALER.MODELS,
    label: "common.model",
    link: MODEL_FORM,
    name: "model",
  },
  {
    code: MODULE.DEALER.CUSTOMERS,
    label: "common.customer",
    link: CUSTOMERS_FORM,
    name: "customer",
  },
  {
    code: MODULE.DEALER.SUBSCRIPTIONS,
    label: "common.subscription",
    link: SUBSCRIPTION_FORM,
    name: "subscription",
  },
];

function getMenu(submodules) {
  const isSuperOwner = store.getters["auth/isSuperOwner"];
  checkSuperOwnerMenu(isSuperOwner);
  menu.children = [];
  menu.createChildren = [];
  submodules.forEach((submodule) => {
    const submenuAux = submenus.find((submenu) => submenu.code === submodule.code);
    const submenuCreateAux = submenusCreate.find(
      (submenu) => submenu.code === submodule.code
    );
    if (submenuAux && (submodule.r || submodule.w)) {
      menu.children.push(submenuAux);
    }
    if (submenuCreateAux && submodule.w) {
      menu.createChildren.push(submenuCreateAux);
    }
  });
  return menu;
}

function checkSuperOwnerMenu(isSuperOwner) {
  submenus.splice(1, 0, {
    code: MODULE.DEALER.DEALER,
    icon: "tribunal-1",
    label: isSuperOwner ? "common.owners" : "common.detail",
    link: isSuperOwner ? DEALER_LIST : DEALER_DETAIL,
    name: "detail",
    tooltip: isSuperOwner ? "common.owners" : "common.detail",
  });
}

export default { getMenu };